import { render, staticRenderFns } from "./StokEkstreAlternatifler.vue?vue&type=template&id=55ccf8fe"
import script from "./StokEkstreAlternatifler.vue?vue&type=script&lang=js"
export * from "./StokEkstreAlternatifler.vue?vue&type=script&lang=js"
import style0 from "./StokEkstreAlternatifler.vue?vue&type=style&index=0&id=55ccf8fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports